module.exports = __webpack_public_path__ + "img/kuaishou.e4d73672.png";